// ref

export const OK = 200 || 201; // Success
export const UNAUTHORIZED = 401; // Unauthorized
